import React, { useEffect, useRef, useState } from "react";
import Lottie from "lottie-react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";

import LottieAnimation from "../../../assets/json/sezione-05-popup-02-it.json";
import arrowIconWhite from "../../../assets/images/arrowIconWhite.png";
import IcoRiconciliabile from "../../../assets/images/ico-riconciliabile.svg";
import IcoNonRiconciliabile from "../../../assets/images/ico-non-riconciliabile.svg";
import GreenIconTick from "../../../assets/images/GreenTick.png";
import YellowIconTick from "../../../assets/images/YellowTick.png";
import BlueIconTick from "../../../assets/images/BlueTick.png";
import Cross from "../../../assets/images/Cross.png";

import MatriceCatenaValore from "../../matrice-catena-valore";

export default function Stakeholder({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Stakeholder e Analisi di materialità", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[999] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Stakeholder e Analisi di materialità"
    >
      <div
        className="
         relative w-full md:w-[1280px] bg-[#E7E3DF] p-6 md:p-8
         max-h-[90vh] overflow-y-auto overscroll-contain
        "
        style={{ background: "#E7E3DF", WebkitOverflowScrolling: "touch" }}
      >
        {/* Azioni in alto */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            onClick={() => onShare("Stakeholder")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Condividi"
            aria-label="Condividi"
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
          </button>
        </div>

        <h2 className="text-[#004996] text-[30px] md:text-[40px] font-bold">Stakeholder e Analisi di materialità</h2>        

        {/* Contenuto */}
        <div className="flex flex-col mt-6 items-start gap-5">
            
            <h3 className="text-[#002655] text-[25px] md:text-[35px]">Stakeholder</h3>
            
            {/* Lottie */}
            <Lottie
              animationData={LottieAnimation}
              loop={false}
              autoplay
              className="w-full md:w-[85%]"
            />

            <a href="https://www.realegroup.eu/groupshare/0/IT/ListaReportsAndAccounts/87/BILANCIO%20CONSOLIDATO%20RG%202025.pdf#page=73" target="_blank">
              <button
                type="button"
                className="bt-secondary text-sm px-4 py-2"
                style={{ background: "#0E3761", color: "#fff" }}
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src={arrowIconWhite}
                  alt="Arrow"
                  className="inline-block mr-2 w-[20px] h-[20px]"
                />
                Consulta il Report - cap. 1 • par. 1.3.2
              </button>
            </a>

            <div>
                <h3 className="text-[#002655] text-[26px] md:text-[35px]">I temi materiali</h3>
                <p className="text-[20px] md:text-[24px]">L’analisi di doppia materialità costituisce uno strumento fondamentale per il Gruppo, non solo in relazione al processo di rendicontazione non finanziaria ma anche per la definizione e pianificazione della strategia di sostenibilità di Gruppo. Nel corso del 2025 Reale Group ha implementato un processo di doppia rilevanza volto a identificare i temi di sostenibilità materiali per il Gruppo lungo tutti gli anelli della catena del valore.</p>
                <p className="text-[20px] md:text-[24px]">Scopri gli esiti dell’Analisi di Materialità 2025 di Reale Group.</p>
            </div>

            {/* Tabella: Dimensione della catena del valore */}
            <div className="w-full py-6">
              <MatriceCatenaValore />
            </div>

            

        </div>

          <a href="https://www.realegroup.eu/groupshare/0/IT/ListaReportsAndAccounts/87/BILANCIO%20CONSOLIDATO%20RG%202025.pdf#page=74" target="_blank">
            <button
              type="button"
              className="bt-secondary text-sm px-4 py-2 mt-8"
              style={{ background: "#0E3761", color: "#fff" }}
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={arrowIconWhite}
                alt="Arrow"
                className="inline-block mr-2 w-[20px] h-[20px]"
              />
              Consulta il Report - cap. 1 • par. 1.3.3
            </button>
          </a>
        </div>
    </div>,
    document.body
  );
}
